'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6;

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SignupButton from 'pricing-pages-unified-ui/components/public-only/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper';
import HR from 'UIComponents/elements/HR';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-unified-ui/selectors/LoadingStateSelectors';
import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import ViewAllFeatures from '../product-pages/ViewAllFeatures';
import { getGAClassName } from 'pricing-pages-lib/utils/publicPageUrls';
import ProductLineToGaMap from '../../constants/ProductLineToGaMap';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { FREE_CARD } from '../../constants/Tracking';
import FreeCardFeatures from './FreeCardFeatures';
const StyledTile = styled(UITile).withConfig({
  displayName: "FreeCard__StyledTile",
  componentId: "sc-5fe8ju-0"
})(["margin-top:16px;", ";", ";"], breakpoint.tablet(_t || (_t = _`
    max-width: initial;
    width: 80%;
    margin: 20px auto 0;
  `)), breakpoint.phone(_t2 || (_t2 = _`
    max-width: initial;
    width: 90%;
  `)));
const StyledTopSection = styled.div.withConfig({
  displayName: "FreeCard__StyledTopSection",
  componentId: "sc-5fe8ju-1"
})(["display:flex;", ""], breakpoint.phoneLarge(_t3 || (_t3 = _`
    flex-direction: column;
  `)));
const ButtonWrapper = styled.div.withConfig({
  displayName: "FreeCard__ButtonWrapper",
  componentId: "sc-5fe8ju-2"
})(["margin-left:auto;", ""], breakpoint.phoneLarge(_t4 || (_t4 = _`
    margin-left: 0;
    margin-top: 16px;
  `)));
const StyledSignupButton = styled(SignupButton).withConfig({
  displayName: "FreeCard__StyledSignupButton",
  componentId: "sc-5fe8ju-3"
})(["", ""], breakpoint.phoneLarge(_t5 || (_t5 = _`
    width: 100%;
  `)));
const MobileFeaturesLink = styled.div.withConfig({
  displayName: "FreeCard__MobileFeaturesLink",
  componentId: "sc-5fe8ju-4"
})(["display:none;flex-direction:column;text-align:center;", ""], breakpoint.phoneLarge(_t6 || (_t6 = _`
    display: flex;
  `)));

const FreeCard = ({
  productLine
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const subtitleKeys = {
    [ProductLines.SALES]: 'pricingPage.freeCard.description.sales',
    [ProductLines.SERVICE]: 'pricingPage.freeCard.description.service',
    [ProductLines.MARKETING]: 'pricingPage.freeCard.description.marketing',
    [ProductLines.OPERATIONS]: 'pricingPage.freeCard.description.operations',
    [ProductLines.CMS]: 'pricingPage.freeCard.description.cms'
  };
  return /*#__PURE__*/_jsxs(StyledTile, {
    children: [/*#__PURE__*/_jsxs(UITileSection, {
      children: [/*#__PURE__*/_jsxs(StyledTopSection, {
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.freeCard.title"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: subtitleKeys[productLine]
            })
          })]
        }), /*#__PURE__*/_jsx(ButtonWrapper, {
          children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            widths: [151],
            heights: [40],
            isLoading: !hasPricingAndPurchasingSucceeded,
            children: /*#__PURE__*/_jsx(StyledSignupButton, {
              sourceId: "pricing-hero",
              productLine: productLine,
              use: "secondary"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(FreeCardFeatures, {
        productLine: productLine
      })]
    }), /*#__PURE__*/_jsxs(MobileFeaturesLink, {
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "flush"
      }), /*#__PURE__*/_jsx("div", {
        className: "m-y-3",
        children: /*#__PURE__*/_jsx(ViewAllFeatures, {
          gaClassName: getGAClassName(`${ProductLineToGaMap[productLine]}free-pricing-features`),
          productLine: productLine,
          use: "inline",
          trackingSource: FREE_CARD
        })
      })]
    })]
  });
};

FreeCard.propTypes = {
  productLine: PropTypes.string
};
export default FreeCard;